import { useMemo } from "react";
import { createDatabaseProvider } from "@hicya/db-client/react";

import { api, initPromise } from "@/db/prewarm";
import type { WorkerApi } from "@/db/worker";

import type { DatabaseProviderConfig } from "@hicya/db-client/react";

const {
  DatabaseProvider: BaseDatabaseProvider,
  useDatabase,
  useIsInMemoryMode,
  useDatabaseStatus,
  DatabaseGate: BaseDatabaseGate,
} = createDatabaseProvider<WorkerApi>();

export { useDatabase, useIsInMemoryMode, useDatabaseStatus };

export function DatabaseProvider({ children }: { children: React.ReactNode }) {
  const config = useMemo<DatabaseProviderConfig<WorkerApi>>(
    () => ({
      api,
      initPromise,
      getIsInMemoryMode: (workerApi) => workerApi.getIsInMemoryMode(),
    }),
    [],
  );

  return <BaseDatabaseProvider config={config}>{children}</BaseDatabaseProvider>;
}

export function DatabaseGate({
  children,
  fallback,
}: {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}) {
  return (
    <BaseDatabaseGate
      fallback={fallback}
      renderError={(error) => (
        <div style={{ padding: 16, textAlign: "center", color: "var(--color-error)" }}>
          Database error: {error}
        </div>
      )}
    >
      {children}
    </BaseDatabaseGate>
  );
}
